export default __webpack_public_path__ + "static/media/demoprofile3.e5b1200b.svg";